import { t } from "@lingui/macro";
import "./Footer.css";
import twitterIcon from "img/ic_twitter.svg";
import discordIcon from "img/ic_discord.svg";
import telegramIcon from "img/ic_telegram.svg";
import githubIcon from "img/ic_github.svg";
import mediumIcon from "img/ic_medium.svg";
import instIcon from "img/ic_instagram.svg";

type Link = {
  text: string;
  link: string;
  external?: boolean;
  isAppLink?: boolean;
};

type SocialLink = {
  link: string;
  name: string;
  icon: string;
};

export const FOOTER_LINKS: { home: Link[]; app: Link[] } = {
  home: [
    { text: t`Terms and Conditions`, link: "/terms-and-conditions" },
    { text: t`Referral Terms`, link: "/referral-terms" },
    { text: t`Media Kit`, link: "https://docs.lif3.com/brand-kit", external: true },
    // { text: "Jobs", link: "/jobs", isAppLink: true },
  ],
  app: [
    { text: t`Media Kit`, link: "https://docs.lif3.com/brand-kit", external: true },
    // { text: "Jobs", link: "/jobs" },
  ],
};

export const SOCIAL_LINKS: SocialLink[] = [
  { link: "https://twitter.com/Official_LIF3", name: "Twitter", icon: twitterIcon },
  // { link: "https://github.com/gmx-io", name: "Github", icon: githubIcon },
  { link: "https://t.me/Lif3_Official", name: "Telegram", icon: telegramIcon },
  { link: "https://discord.com/invite/lif3", name: "Discord", icon: discordIcon },
  { link: "https://official-lif3.medium.com/", name: "Medium", icon: mediumIcon },
  { link: "https://www.instagram.com/lif3official/", name: "Instagram", icon: instIcon },
];
